export const PAYMENT_ORDER_API_PATHS = {
  CREATE_VIRTUAL_PRODUCT_ORDER: '/v2/payment-order/v1/orders/purchase/product',
  CREATE_RECHARGE_ORDER: '/v2/payment-order/v1/orders/purchase/recharge',
  GET_PURCHASE_PREVIEW: '/v2/payment-order/v1/orders/purchase/preview',
  GET_PRODUCTS: '/v2/payment-order/v1/products',
  INITIATE_PAYMENT: '/v2/payment-order/v1/payments/initiate',
  GET_ORDER_STATUS: (orderNumber: string) =>
    `/v2/payment-order/v1/orders/${orderNumber}`,
  GET_FALLBACK_PAYMENT_PROVIDERS: (orderNumber: string) =>
    `/v2/payment-order/v1/orders/${orderNumber}/fallback-payment-providers`,
  CANCEL_VIRTUAL_PRODUCT_ORDER: (orderNumber: string) =>
    `/v2/payment-order/v1/orders/${orderNumber}/cancel`,
  GET_ORDERS: '/v2/payment-order/v1/orders',
  CANCEL_SUBSCRIPTION: '/v2/payment-order/v1/orders/cancel-subscription',
  GET_CREDIT_HISTORY: '/v2/payment-order/v1/credits/history',
  GET_PRODUCT_PURCHASES: '/v2/payment-order/v1/products/purchases',
  GET_PENDING_PAYMENTS_NOTIFICATION:
    '/v2/payment-order/v1/orders/notifications/pending-payments',
} as const;
